import { useGlobal } from '../hooks/useGlobal';
import { ReactNode, useMemo } from 'react';
import { CSSVarThemeProvider, findClosestColor, theme, Theme } from 'rwl-ui';

const BROWSER_DEFAULT_FONTS = ['times new roman', 'times', 'serif'];

function getHostFontFamily(): string {
    if (typeof window === 'undefined') return theme.typography.fontFamily;

    const root = document.getElementById('rwl-neighborhood-root');
    if (!root) return theme.typography.fontFamily;

    const computed = window.getComputedStyle(root).fontFamily.toLowerCase();
    const isDefault = BROWSER_DEFAULT_FONTS.some(
        (font) => computed === font || computed === `"${font}"`
    );

    return isDefault ? theme.typography.fontFamily : 'inherit';
}

export const BrandProvider = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element | null => {
    const { config } = useGlobal();

    const neighborhoodTheme: Theme = useMemo(
        () => ({
            ...theme,
            typography: {
                ...theme.typography,
                fontFamily: getHostFontFamily(),
            },
        }),
        []
    );

    const colorOverrides = useMemo(() => {
        if (!config?.account) {
            return;
        }
        if (config.account.mapSettings?.color) {
            return {
                primary: findClosestColor(config.account.mapSettings.color),
            };
        }

        return {};
    }, [config]);
    return (
        <>
            <CSSVarThemeProvider
                theme={neighborhoodTheme}
                global={true}
                colorOverrides={colorOverrides}
            />
            {children}
        </>
    );
};
